<template>
    <van-action-sheet v-model="show">
        <van-area :value="fieldValue" :area-list="areaList" :columnsNum="columnsNum" @confirm="onConfirm"
            @cancel="onCancel" />
    </van-action-sheet>
</template>
<script>
import { areaList } from "@vant/area-data";
export default {
    name: 'selectCityPopup',
    props: {
        showSelectCityPopup: {
            type: Boolean,
            default: false
        },
        select: {
            type: Array,
            default: () => ([])
        },
        columnsNum: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            fieldValue: '',
            areaList: areaList
        }
    },
    computed: {
        show: {
            get() {
                return this.showSelectCityPopup
            },
            set(value) {
                this.$emit("update:showSelectCityPopup", value);
            }
        },
        selectValue: {
            get() {
                return this.select
            },
            set(value) {
                this.$emit("update:select", value);
            }
        }
    },
    methods: {
        onConfirm(list) {
            this.fieldValue = list[list.length - 1].code
            this.selectValue = list.map(item => item.name)
            this.show = false;
        },
        onCancel() {
            this.show = false;
        },
    },
    watch: {
        show: {
            handler(value) {
                // 回显逻辑
                if (value && this.select?.length > 0) {
                    const { city_list, county_list, province_list } = this.areaList
                    const list = { 1: province_list, 2: city_list, 3: county_list }[this.columnsNum]
                    Object.entries(list).forEach(([key, value]) => {
                        if (value === this.select[this.select.length - 1]) {
                            this.fieldValue = key
                        }
                    })
                }
            },
            immediate: true,
        },
    }
}
</script>
<style lang="scss" scoped></style>